// extracted by mini-css-extract-plugin
export default {"imgContain":"oE","content":"pE","titleAndImage":"qE","title":"rE","text":"sE","rhodeTitle":"tE","shortHR":"uE","modal_root":"vE","x_mark":"wE","flavorStickModal":"xE","greenBox":"yE"};
    if(module.hot) {
      // 1713361651118
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  